import React from "react";

function ServiceBlock({ img, title, service, props, num }) {
  return (
    <button
      className="border-0 service-btn boder-danger"
      onClick={() => props.history.push(`/listing/service=${service}`)}
    >
      {title} <span style={{ fontWeight: "800" }}>({num})</span>
    </button>
  );
}

export default ServiceBlock;
